import type { Widen } from '../catalogue';
import type { svProjects } from '../sv/projects';

export const enProjects: Widen<typeof svProjects> = {
  context: {
    loadFailed: 'Failed to load projects',
    deleted: 'Project deleted',
    deleteFailed: 'Deleting project failed',
    deleteProject: 'Delete the project',
    permanentWarning: 'This action is <b>permanent</b>, and will delete all data',
    deleteTitle: 'Delete the project?'
  },
  list: {
    title: 'Projects',
    addProject: 'Add project',
    importCsv: 'Import CSV',
    exportCsv: 'Export CSV',
    columnName: 'Project Name',
    columnOrganisation: 'Organisation',
    columnStatus: 'Status',
    empty: 'There are no projects yet.',
    unableToAdd: 'Unable to add {{name}}',
    csvBadFormat: 'CSV is incorrectly formatted',
    importSuccessful: 'Import successful',
    importFailed: 'CSV failed to import',
    importPartial_one: 'Import partially successful, but line {{lines}} failed to import.',
    importPartial_other: 'Import partially successful, but lines {{lines}} failed to import.',
    linkFailed: 'Could not create the camera link.',
    linkTryLater: 'Something went wrong. Try again later!',
    saveLinkFailed: 'Could not save the new link on the project'
  },
  create: {
    insertName: 'Insert a project name',
    selectOrganisation: 'Select an organisation',
    created: 'Project {{name}} added',
    createFailed: 'Could not add the project.',
    title: 'Add project',
    projectName: 'Project name',
    organisation: 'Organisation',
    status: 'Status',
    createProject: 'Add project'
  },
  view: {
    wrongId: 'Wrong project ID',
    notFound: 'Project not found',
    badData: 'Something wrong with project data',
    updated: 'Project {{name}} saved',
    updateFailed: 'Could not save the project.',
    projectName: 'Project name',
    nameMissing: 'Enter a project name',
    organisation: 'Organisation',
    status: 'Status',
    update: 'Save',
    edit: 'Edit',
    editTitle: 'Edit project',
    cameraLink: 'Camera link and QR',
    statusLine: 'Status: {{status}}',
    noStatus: 'No status',
    mediaCount_one: '{{count}} media item',
    mediaCount_other: '{{count}} media items',
    drawingCount_one: '{{count}} drawing',
    drawingCount_other: '{{count}} drawings',
    mediaTitle: 'Media items in the project',
    drawingsTitle: 'Drawings',
    noMedia: 'No media items in the project.',
    noDrawings: 'No drawings in the project.',
    otherOrg: 'Media items and drawings are shown for projects in the organisation you work in.'
  },
  drawings: {
    name: 'Name',
    project: 'Project',
    noProject: 'No project',
    newDrawing: 'Add drawing',
    saved: 'Drawing saved',
    readFailed: 'Could not read the drawing',
    saveFailed: 'Could not save the drawing',
    file: 'File',
    position: 'Position (click the map)',
    saving: 'Saving…',
    title: 'Drawings',
    pages: 'Pages',
    pinnedPhotos: 'Pinned photos',
    empty: 'No drawings yet.'
  },
  viewer: {
    loading: 'Loading...',
    notFound: 'Drawing not found',
    updateFailed: 'Could not update the drawing',
    deleted: 'Drawing deleted',
    deleteFailed: 'Could not delete the drawing',
    pageOf: 'Page {{page}} of {{total}}',
    previous: 'Previous',
    next: 'Next',
    rename: 'Rename',
    move: 'Move',
    downloadPdf: 'Download PDF',
    downloadReport: 'Download report',
    reportFailed: 'Could not create the report',
    reportTooManyPins: 'The drawing has more than 200 pins',
    pageAlt: '{{name}}, page {{page}}',
    photosOnPage: 'Photos on this page ({{number}})',
    renameTitle: 'Rename drawing',
    moveTitle: 'Move drawing',
    deleteTitle: 'Delete drawing',
    deleteBody: 'The drawing will be deleted. Its photos stay, but lose their place on the drawing.',
    deleteConfirm: 'Delete drawing',
    pinsFromMobile: 'No photos on this page yet. Pins are placed in the mobile app with "Take photo here".'
  }
};
